/**
 * Coach (sparkle) nav target.
 *
 * `/chat` auto-resumes the last thread. That is correct when opening Coach from
 * another page. When the user is already on Coach, going to `/chat` again
 * flashes them back into the open conversation and hides the starter topic boxes.
 * In that case open a new conversation (`?new=1`) so the topic boxes return.
 */
export function isCoachPath(pathname: string): boolean {
  return pathname === '/chat' || pathname.startsWith('/chat/')
}

export function coachNavTarget(pathname: string): string {
  return isCoachPath(pathname) ? '/chat?new=1' : '/chat'
}
